import React from 'react';
import AutocompleteSelect from '../../../shared/AutocompleteSelect';

export default function MobileFilterAutocomplete(props) {
  return <AutocompleteSelect {...props} className='mp-filter-autocomplete' />;
}
